import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";
import { LuxButton, Eyebrow } from "@/components/lux";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#090A0F] grain flex flex-col items-center justify-center text-center px-6" data-testid="not-found">
      <div className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 h-[380px] w-[380px] rounded-full bg-[#02AACF]/12 blur-[120px]" />
      <img src={LOGO_URL} alt="LUHAI" className="h-10 mb-10 relative" />
      <p className="font-display font-bold text-[#02AACF] text-7xl sm:text-8xl relative">404</p>
      <Eyebrow className="block mt-6 relative">Frame not found</Eyebrow>
      <h1 className="font-display font-bold text-white text-2xl sm:text-3xl mt-3 max-w-lg relative">
        Looks like this frame didn't make the final edit.
      </h1>
      <LuxButton className="mt-8 relative" onClick={() => navigate("/")} data-testid="notfound-home">RETURN HOME</LuxButton>
    </div>
  );
}
